export const isManualPath = (pathname: string): boolean =>
  pathname.toLowerCase().replace(/\/+$/, '') === '/manual';

export const MANUAL_ROBOTS_POLICY = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
